import { api } from './configs/axiosConfig'
import { defineCancelApiObject } from './configs/axiosUtils'

export const houseApi = {
  getHouseItems: async function (trackingSysId, houseNum, cancel = false) {
    const response = await api.request({
      url: `${process.env.REACT_APP_GIANT_API_URL}/HouseCisco/housenums`,
      method: "GET",
      withCredentials: true,
      params: { trackingSystemId: trackingSysId, houseNumber: houseNum },
      signal: cancel ? cancelApiObject[this.get.name].handleRequestCancellation().signal : undefined,
    })

    return response.data.data
  },

  getHouseByNum: async function (trackingSysId, houseId, cancel = false) {
    const response = await api.request({
      url: `${process.env.REACT_APP_GIANT_API_URL}/HouseCisco/houseformresponse`,
      method: "GET",
      withCredentials: true,
      params: {
        trackingSysId: trackingSysId,
        houseId: houseId
      },
      signal: cancel ? cancelApiObject[this.get.name].handleRequestCancellation().signal : undefined,
    })

    return response.data.data
  }

}

const cancelApiObject = defineCancelApiObject(houseApi)